import { render } from "./CarouselSlider.vue?vue&type=template&id=30cb0548&scoped=true"
import script from "./CarouselSlider.vue?vue&type=script&lang=js"
export * from "./CarouselSlider.vue?vue&type=script&lang=js"

import "./CarouselSlider.vue?vue&type=style&index=0&id=30cb0548&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cb0548"]])

export default __exports__